import { render, staticRenderFns } from "./badInvoice.vue?vue&type=template&id=3675ab1c&"
import script from "./badInvoice.vue?vue&type=script&lang=js&"
export * from "./badInvoice.vue?vue&type=script&lang=js&"
import style0 from "./badInvoice.vue?vue&type=style&index=0&id=3675ab1c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports